export default __webpack_public_path__ + "static/media/waiter.d0516bd5.svg";